import {cursorIsWithinBounds} from './ui-utils';

function showAndPlacePopup($popup: HTMLElement, bounds: DOMRect) {
	if ($popup.classList.contains('pp-popup-below')) {
		if (window.innerWidth - bounds.left > $popup.clientWidth) {
			$popup.style.left = `${bounds.left}px`;
		} else {
			$popup.style.right = '8px';
		}

		$popup.style.top = `${bounds.bottom}px`;
	} else if ($popup.classList.contains('pp-popup-right')) {
		$popup.style.left = `${bounds.right}px`;
		$popup.style.top = `${bounds.top}px`;
	} else if ($popup.classList.contains('pp-popup-left')) {
		$popup.style.right = `${bounds.left}px`;
		$popup.style.top = `${bounds.top}px`;
	} else {
		const midX = bounds.left + ((bounds.right - bounds.left) / 2);
		$popup.style.left = `${midX}px`;
		$popup.style.top = `${bounds.top}px`;
	}

	$popup.classList.add('shown');
}

/**
 * Displays the popup on event trigger.
 */
// eslint-disable-next-line max-params
function handlePopup(event: Event, $popupParent: HTMLElement, $popup: HTMLElement, shouldCheckBounds: Boolean, triggerEventType: string) {
	if ($popupParent.querySelector<HTMLElement>('.pp-fees-editor')?.style.visibility === 'visible') {
		return;
	}

	if ($popupParent.querySelector('.rate') === document.activeElement) {
		return;
	}

	const bounds = $popupParent.getBoundingClientRect();

	if (!cursorIsWithinBounds(event, bounds) && shouldCheckBounds) {
		return;
	}

	showAndPlacePopup($popup, bounds);

	/* Disappear when not hovered or scrolled */
	if (triggerEventType === 'mousemove') {
		document.addEventListener('mousemove', event => {
			if (!cursorIsWithinBounds(event, $popup.getBoundingClientRect()) && !cursorIsWithinBounds(event, $popupParent.getBoundingClientRect())) {
				hidePopup($popup);
			}
		});

		document.addEventListener('scroll', event => {
			if (!cursorIsWithinBounds(event, $popup.getBoundingClientRect()) && !cursorIsWithinBounds(event, $popupParent.getBoundingClientRect())) {
				hidePopup($popup);
			}
		});
	}

	/* Disappear when clicked outside */
	if (triggerEventType === 'click') {
		document.addEventListener('click', event => {
			if (!cursorIsWithinBounds(event, $popup.getBoundingClientRect()) && !cursorIsWithinBounds(event, $popupParent.getBoundingClientRect())) {
				hidePopup($popup);
			}
		});
	}
}

/**
 * Hides the popup on event trigger.
*/
function hidePopup($popup: HTMLElement) {
	$popup.classList.remove('shown');
}

/**
 * Sets up event listeners for popups that show above a hovered element.
 */
function initPopups() {
	document.querySelectorAll('.pp-popup-mousemove-trigger').forEach(($trigger: HTMLElement) => {
		$trigger.addEventListener('mousemove', event => {
			const $popup = $trigger.querySelector('.pp-popup');
			if ($popup) {
				handlePopup(event, $trigger, $popup as HTMLElement, true, 'mousemove');
			}
		});
	});
	document.querySelectorAll('.pp-popup-click-trigger').forEach(($trigger: HTMLElement) => {
		const $popup = $trigger.querySelector('.pp-popup');
		$trigger.addEventListener('click', event => {
			const $popupParent = $trigger.closest('#pp-currency-rate-column') ?? $trigger;
			if ($popupParent) {
				handlePopup(event, $popupParent as HTMLElement, $popup as HTMLElement, true, 'click');
			}
		});
	});
}

export {initPopups};
